import React from 'react';
import fr from 'facet-rest';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import Container from './Container';

const HouseholdNextAction = () => {
  const { clientDashboardResource } = useDashboardContext();

  return (
    <Container
      relationshipLink={clientDashboardResource?.relationship(fr.relationships.householdNextAction.name)?.link('related')}
    />
  );
};

export default HouseholdNextAction;
